import React from "react";
import { ReactFlowProvider } from "@xyflow/react";

import ActivityRendererNew from "./ActivityRendererNew";
import { useParams } from "react-router-dom";

const ActivityJobFlow = ({ activityData, setActivityData, allStatesActivityObj, allJobs, currentTab }) => {
  const { smId, activityId } = useParams();
  const settingPreActivityData = (data) => {
    setActivityData({ ...activityData, pre_activity_job: data });
  };

  const settingPreSubmission = (data) => {
    setActivityData({ ...activityData, pre_submission: data });
  };

  const setJobTriggerFormula = (data) => {
    setActivityData({ ...activityData, jobs_trigger_formula: data });
  };

  const settingJobTriggerData = (data) => {
    setActivityData({ ...activityData, jobs_trigger: data });
  };

  const settingStateChangeLogic = (data) => {
    setActivityData({ ...activityData, state_change_logic: data });
  };

  const setJobFlowVisibility = (jobFlowStates) => {
    setActivityData((prev) => {
      prev.job_flow_states = jobFlowStates;

      return prev;
    });
  };

  const setPositions = (positions) => {
    setActivityData((prev) => {
      const copy = { ...prev };
      copy.positions = positions;

      return prev;
    });
  };

  const settingActivityChangeLogic = (data) => {
    setActivityData({ ...activityData, activity_change_logic: data });
  };

  if (!activityData) return <div />;

  return (
    <ReactFlowProvider>
      <ActivityRendererNew
        config={activityData}
        settingPreActivityData={settingPreActivityData}
        settingPreSubmission={settingPreSubmission}
        setJobTriggerFormula={setJobTriggerFormula}
        settingJobTriggerData={settingJobTriggerData}
        settingStateChangeLogic={settingStateChangeLogic}
        settingActivityChangeLogic={settingActivityChangeLogic}
        setPositions={setPositions}
        logic={activityData}
        selectionObj={allStatesActivityObj}
        jobTriggerFormula={activityData.jobs_trigger_formula}
        stateid={smId}
        actId={activityId}
        setJobFlowVisibility={setJobFlowVisibility}
        allJobs={allJobs}
        currentTab={currentTab}
      />
    </ReactFlowProvider>
  );
};

export default ActivityJobFlow;
